import React, { useEffect } from 'react';

import useResizeBar from '@dashboard/hooks/useResizeBar';
import { Box, Paper, Stack } from '@mui/material';
import { useCurrentSidebarTab } from '@wp-block-builder/editor/hooks';

import { useCurrentTemplateType } from '../hooks';

import DataSidebar from './DataSidebar';
import GeneralSidebar from './GeneralSidebar';
import InspectSidebar from './InspectSidebar';
import SidebarTabs from './SidebarTabs';
import StylesSidebar from './StylesSidebar';

export default function Sidebar() {
  const [selectedTab, setSelectedTab] = useCurrentSidebarTab();
  const { width, resizeBar } = useResizeBar({
    defaultWidth: 400,
    position: 'left',
  });
  const type = useCurrentTemplateType();

  useEffect(() => {
    if (type === 'LAYOUT') {
      setSelectedTab('STYLES');
    }
  }, [type, setSelectedTab]);

  const getCurrentPanel = () => {
    switch (selectedTab) {
      case 'GENERAL':
        return <GeneralSidebar />;
      case 'DATA':
        return <DataSidebar />;
      case 'STYLES':
        return <StylesSidebar />;
      case 'INSPECT':
        return <InspectSidebar />;
    }
  };
  return (
    <Stack
      component={Paper}
      direction="row"
      justifyContent="space-between"
      sx={{
        width: { md: width },
        maxWidth: { md: 'calc(100vw - 600px)' },
        minWidth: { md: 296 },
        height: '100%',
        position: 'relative',
        zIndex: 1,
        overflowX: 'hidden',
      }}
    >
      <Stack sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
          <SidebarTabs />
        </Box>
        <Box sx={{ overflowY: 'auto', height: '100%' }}>{getCurrentPanel()}</Box>
      </Stack>
      {resizeBar}
    </Stack>
  );
}
